import React from 'react';

import PropTypes from 'prop-types';

export default function OtherOptions(props) {
  const blinkClassName = props.blink ? ' other-options--blink' : '';
  const disabledClassName = props.disabled ? ' tw-text-grey-300' : '';

  const dots = [...Array(3)].map((_, index) => (
    <span
      className='other-options__dot before:tw-align-middle before:tw-text-[5px]'
      key={index}
      style={{ '--tw-content': '"\\25CF"' }}
    />
  ));

  return (
    <div
      className={`other-options${blinkClassName}${disabledClassName} tw-leading-[5px]`}
    >
      {dots}
    </div>
  );
}

OtherOptions.propTypes = {
  blink: PropTypes.bool.isRequired,
  disabled: PropTypes.bool,
};

OtherOptions.defaultProps = {
  disabled: false,
};
